// Authentication Pages

export default [
  {
    params: {
      path: "/site/admin",
      name: "Login",
      meta: { layout: "full" },
    },
    defaultComponentPath: "Pages/Authentication/Login/Login",

  },
  {
    params: {
      path: "/site/:data",
      name: "LoginCompany",
      meta: { layout: "full" },
    },
    defaultComponentPath: "Pages/Authentication/Login/Login",

  },
  {
    params: {
      path: "/forgot-password",
      name: "ForgotPasswordPage",
      meta: { layout: "full" },
    },
    defaultComponentPath: "Pages/Authentication/ForgotPassword/ForgotPassword",
  },
  {
    params: {
      path: "/assign-password/:data",
      name: "AssignPassword",
      meta: { layout: "full" },
    },
    defaultComponentPath: "Pages/Authentication/AssignPassword/AssignPassword",
  },
  {
    params: {
      path: "/main",
      name: "Main",
    },
    defaultComponentPath: "Pages/Main",
    navs: true,
  },
  {
    params: {
      path: "/dashboard/qos/",
      name: "dashboardCalidadServicio",
      meta: { id: 1 },
    },
    defaultComponentPath: "Pages/Dashboards/DashboardBase",
    navs: true,
  },
  {
    params: {
      path: "/dashboard/realtime",
      name: "dashboardTiempoReal",
      meta: { id: 2 },
    },
    defaultComponentPath: "Pages/Dashboards/DashboardBase",
    navs: true,
  },
  {
    params: {
      path: "/dashboard/agent",
      name: "dashboardAgente",
      meta: { id: 3 },
    },
    defaultComponentPath: "Pages/Dashboards/DashboardBase",
    navs: true,
  },
  {
    params: {
      path: "/dashboard/callDetail",
      name: "buscadorDetalleLlamada",
    },
    defaultComponentPath: "Pages/DashboardCall/DashboardCall",
    navs: true,
  },
  {
    params: {
      path: "/dashboard/callDetailUser",
      name: "buscadorDetalleLlamadaUser",
    },
    defaultComponentPath: "Pages/DashboardCall/DashBoardCallUser",
    navs: true,
  },
  {
    params: {
      path: "/dashboard/lifecycle",
      name: "dashboardCicloVida",
      meta: { id: 4 },
    },
    defaultComponentPath: "Pages/Dashboards/DashboardBase",
    navs: true,
  },
  {
    params: {
      path: "/admin/nodes",
      name: "adminNodos",
    },
    defaultComponentPath: "Pages/Nodes/Nodes",
    navs: true,
  },
  {
    params: {
      path: "/admin/users",
      name: "adminUsers",
      meta: { viewSuperUser: false },
    },
    defaultComponentPath: "Pages/Users/Users",
    navs: true,
  },
  {
    params: {
      path: "/admin/groups",
      name: "adminGroups",
      meta: { viewSuperUser: false },
    },
    defaultComponentPath: "Pages/Groups/Groups",
    navs: true,
  },
  {
    params: {
      path: "/admin/superUsers",
      name: "adminSuperUsers",
      meta: { viewSuperUser: true },
    },
    defaultComponentPath: "Pages/Users/Users",
    navs: true,
  },
  {
    params: {
      path: "/admin/companies",
      name: "adminCompanies",
    },
    defaultComponentPath: "Pages/Companies/Companies",
    navs: true,
  },
  {
    params: {
      path: "/admin/offices",
      name: "adminOffices",
    },
    defaultComponentPath: "Pages/Offices/Offices",
    navs: true,
  },
  {
    params: {
      path: "/admin/reports",
      name: "reportsMaganement",
    },
    defaultComponentPath: "Pages/Reports/Reports",
    navs: true,
  },
  {
    params: {
      path: "/queues",
      name: "QueuesView",
    },
    defaultComponentPath: "Pages/Queues/Queues",
    navs: true,
  },
  {
    params: {
      path: "*",
      name: "PageNotFound",
      meta: { layout: "full" },
    },
    defaultComponentPath: "Pages/Errors/Error404",
  },
];
